import { Injectable } from '@angular/core';

import { UtilsService } from './_utils.service';
import { NetworkStatusService } from './network-status.service';

@Injectable({
  providedIn: 'root'
})
export class InspectionTemplateDownloadService {

  constructor(
    private networkStatusService: NetworkStatusService,
    private utilsService: UtilsService
  ) { }

  async downloadInspectionTemplate(blob: Blob, inspectionName: string) {
    if (!this.networkStatusService.isBrianMode) {
      this.utilsService.download(blob, inspectionName + '.zip', null);
    }
  }

}
